<template>
  <div class="w-full">
    <div class="mapH z-10">
      <l-map :zoom="zoom" :center="center" style="height: 100%; width: 100%">
        <l-tile-layer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
        ></l-tile-layer>
        <l-marker
          v-for="station in stations"
          :key="station.id"
          :lat-lng="[station.lat, station.lon]"
          @click="setDetails(station)"
        >
          <l-icon
            :icon-url="require('@/assets/images/gps.png')"
            :icon-size="[50, 50]"
            :icon-anchor="[25, 25]"
          >
          </l-icon>
          <!-- <l-popup>
            <div>
              <img class="rounded-md" :src="station.img_url" alt="" />
              <h3>{{ station.name }}</h3>
              <p>{{ station.address }}</p>
              <p>{{ station.chargers }}</p>
              <p>{{ station.openHours }}</p>

            </div>
          </l-popup> -->
        </l-marker>
        <l-marker v-if="userLongLat" :lat-lng="userLongLat">
          <l-popup> <p>User's Location</p></l-popup>
        </l-marker>
      </l-map>
    </div>
    <StationDetailsSlider
      :closeSlider="closeSlider"
      :sliderOpen="sliderOpen"
      :station="{
        ...selectedStation,
        img: selectedStation.img,
        id: selectedStation.id,
      }"
    />
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from "vue2-leaflet";
import StationDetailsSlider from "../MapView/StationDetailsSlider.vue";
import { Icon } from "leaflet";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    StationDetailsSlider,
  },
  props: {
    stations: {
      type: Array,
      required: true,
    },
    userLongLat: {
      type: Array,
      default: () => [6.561276807647162, 3.379541414521732], // Default coordinates
    },
  },
  computed: {
    center() {
      return this.userLongLat
        ? this.userLongLat
        : [6.561276807647162, 3.379541414521732];
      // return [6.561276807647162, 3.379541414521732];
    },
  },
  data() {
    return {
      sliderOpen: false,
      zoom: 12,
      selectedStation: {},
      // center: [6.4342157181173985, 3.4126978631587934], // Default center
    };
  },
  methods: {
    openSlider() {
      this.sliderOpen = true;
    },
    closeSlider() {
      this.sliderOpen = false;
    },
    setDetails(station) {
      this.selectedStation = station;
      // console.log(this.selectedStation);

      this.openSlider();
    },
    // handleButtonClick(station) {
    //   // console.log(station);

    //   // Handle button click for the specific station
    //   alert("Button clicked for station: " + station.id);
    //   // You can add more logic here, like opening a modal or redirecting
    // },
  },
  mounted() {
    // alert("this.userLongLat: " + this.userLongLat);
  },
};
</script>

<style scoped>
.mapH {
  height: 90vh;
  width: 100%;
  @apply mx-auto relative overflow-hidden;
}
</style>